import { useEffect, useState } from 'react'

const areaIdFromHash = () => {
  const match = window.location.hash.match(/^#\/area\/([^/]+)$/)
  return match ? decodeURIComponent(match[1]) : null
}

export const useAreaRoute = () => {
  const [areaId, setAreaId] = useState<string | null>(areaIdFromHash)

  useEffect(() => {
    if (!window.location.hash) window.history.replaceState({ leveleriaRoot: true }, '', '#/')
    const update = () => setAreaId(areaIdFromHash())
    window.addEventListener('popstate', update)
    window.addEventListener('hashchange', update)
    return () => {
      window.removeEventListener('popstate', update)
      window.removeEventListener('hashchange', update)
    }
  }, [])

  const openArea = (id: string) => {
    window.history.pushState({ leveleriaInternal: true }, '', `#/area/${encodeURIComponent(id)}`)
    setAreaId(id)
  }

  const goHome = () => {
    if (window.history.state?.leveleriaInternal) window.history.back()
    else {
      window.history.replaceState({ leveleriaRoot: true }, '', '#/')
      setAreaId(null)
    }
  }

  return { areaId, openArea, goHome }
}
